import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function MapleOSVsWindows() {
  const page = getSemanticPageByPath('/mapleos-vs-windows');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
